import { render, staticRenderFns } from "./ClientNeedsPopUp.vue?vue&type=template&id=2d9ae89c&scoped=true&"
import script from "./ClientNeedsPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientNeedsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientNeedsPopUp.vue?vue&type=style&index=0&id=2d9ae89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9ae89c",
  null
  
)

export default component.exports